import { Box, styled } from '@mui/material';
import { useMemo } from 'react';
import { getEmbeddedComponents, ComponentType } from '@gcportal/base';
import React from 'react';
import { AdditionalColors } from '@gc-bridge/theme/colors';
import { additionalInfoSections } from '@gc-bridge/constants';
import { AdditionalInfoSection } from '@gc-bridge/components/AdditionalInfo/Section';
import { groupBy } from 'lodash';

const Container = styled(Box)({
  width: '95%',
  margin: '-75px auto 0 auto',
  backgroundColor: AdditionalColors.MilkyWay,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  position: 'relative',
  zIndex: 2,
});

export function AdditionalInfo() {
  const componentsBySection = useMemo(() => {
    const homePageAdditionalInfoComponents = getEmbeddedComponents(ComponentType.HomePageAdditionalInfo)
      .map((component) => {
        if (component.lazy) {
          return {
            ...component,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            element: React.lazy(component.load as any),
          };
        }
        component.load();
        return {
          ...component,
          element: component.element,
        };
      });
    return groupBy(
      homePageAdditionalInfoComponents,
      (remote) => remote.additionalInfoSection
    );
  }, []);

  if (!Object.values(componentsBySection).some((components) => components.length)) {
    return;
  }

  return (
    <Container>
      {additionalInfoSections.map((section) => (
        <AdditionalInfoSection
          key={section.title}
          section={section}
          components={componentsBySection[section.title] || []}
        />
      ))}
    </Container>
  );
}
